import TopNCompaniesSelectionItem from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/TopNCompaniesSelectionItem";

import type SelectionDropdown from "../../../table-actions-panel/models/selection-dropdown/SelectionDropdown";
import AllResultsSelectionItem from "../../../table-actions-panel/models/selection-dropdown-item/AllResultsSelectionItem/AllResultsSelectionItem";
import TopNRemainingSelectionItem from "../../../table-actions-panel/models/selection-dropdown-item/TopNRemainingSelectionItem/TopNRemainingSelectionItem";
import type { SelectionDropdownItem } from "../../../table-actions-panel/models/selection-dropdown-item/types";
import { getItemWithTheSmallestValueOrManual } from "../../../table-actions-panel/utils/selection-dropdown";

type Deps = {
    topNValues: readonly number[];
};

export default function createSaveToListSelectionDropdown(deps: Deps): SelectionDropdown {
    return {
        getInitiallySelectedItem: getItemWithTheSmallestValueOrManual,
        getItems(numberOfResults: number, limit = Number.POSITIVE_INFINITY): SelectionDropdownItem[] {
            const maximumPossibleValue = Math.min(numberOfResults, limit);

            if (maximumPossibleValue <= 0) {
                return [];
            }

            const possibleTopNValues = deps.topNValues.filter((value) => value < maximumPossibleValue);
            const topNItems: SelectionDropdownItem[] = possibleTopNValues.map((value) => {
                return new TopNCompaniesSelectionItem({ value, id: `top-${value}` });
            });

            if (limit <= numberOfResults) {
                return topNItems.concat(new TopNRemainingSelectionItem({ id: `top-${limit}`, value: limit }));
            }

            return topNItems.concat(new AllResultsSelectionItem(numberOfResults) as SelectionDropdownItem);
        },
    };
}
